module.exports = __webpack_public_path__ + "static/img/bg-id.663d8d32.png";